module.exports = __webpack_public_path__ + "static/media/sensor-icon.5110270b.svg";